import {
  ENV_CONFIGS,
  PAYMENT_METHODS,
  RAZORPAY_SCRIPT_URL,
} from "constants/constants";
import { useSelector } from "react-redux";
import { loadScriptIntoDOM } from "utils/commonMethods";

function useRazorpay(cUID, onPaymentSuccess, onPaymentFailure) {
  //loads razorpay script into dom
  loadScriptIntoDOM(RAZORPAY_SCRIPT_URL);
  const vendingMachineDetails = useSelector((state) => state.vmDetailsReducer);

  window.paymentObject = {};
  //Activates razorpay modal.
  const activateRazorpayModal = function (
    amount,
    gatewayOID,
    paymentMethod,
    backendOrderId
  ) {
    const options = {
      key: ENV_CONFIGS.RAZORPAY_KEY,
      amount: (amount * 100).toString(),
      currency: "INR",
      name: "Vendify",
      order_id: gatewayOID,
      timeout: vendingMachineDetails.configurations.payment_timeout,

      theme: {
        hide_topbar: true,
        color: "#ef4e49",
        backdrop_color: "#eeeeee",
      },
      handler: function () {
        onPaymentSuccess(cUID, backendOrderId, gatewayOID);
      },
      modal: {
        ondismiss: function () {
          onPaymentFailure(backendOrderId, gatewayOID);
        },
        backdropclose: false,
        escape: false,
        handleback: false,
        confirm_close: true,
      },
      retry: {
        enabled: false,
        max_count: 0,
      },
    };
    //Prefill the data only for UPI to avoid cards save or unexpected wallet OTP.
    if (paymentMethod === PAYMENT_METHODS.UPI.code) {
      options.prefill = {
        email: "support@vendify.in", //dummy
        contact: "+919999999999", //dummy
        method: paymentMethod,
      };
    }

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
    paymentObject.on("payment.failed", function () {
      onPaymentFailure(backendOrderId, gatewayOID);
    });
    window.paymentObject.close = function () {
      //Hides container to enable pointer events
      document.querySelector(".razorpay-container").style.display = "none";
      return paymentObject.close();
    };
  };

  return [activateRazorpayModal];
}

export default useRazorpay;
